var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "1453 1536.95 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1453 1555.9a19 19 0 1 1 0 .1z",
    fill: "#fff4e5",
    fillRule: "evenodd",
    "data-name": "Icon.BG"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "alert-circle-exc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1472 1548c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1Zm1-3h-2v-5h2v5Z",
    fill: "#ffca83",
    fillRule: "evenodd",
    "data-name": "Path 257"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseLeftIcon);
export default __webpack_public_path__ + "static/media/courseLeft_icon.cb9acf33d99e4eb9414d9839666a779b.svg";
export { ForwardRef as ReactComponent };